import OrganisationDetailsCard from './OrganisationDetailsCard'
export default OrganisationDetailsCard